import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../redux/store'
import { ScientificDayInterface, ShowScientificDayContext, modalType } from './types'
import { useTranslation } from 'react-i18next'
import { formatDate } from '../../functions/functions'
import ToggleImages from './ToggleImages'
import { FaEdit } from 'react-icons/fa'
import { MdRemoveCircleOutline } from 'react-icons/md'

const DataScientificDay = () => {
  const { scientificDays } = useSelector((state: State) => state.ScientificDays)
  const { t } = useTranslation()

  const { 
    setSelectedScientificDay,
    showEditScientificDayModal, setShowEditScientificDayModal,
    showDeleteScientificDayModal, setShowDeleteScientificDayModal,
    setSelectedModal
  } = useContext(ShowScientificDayContext)

  const toggleEditModal = (ScientificDay: ScientificDayInterface) => {
    setShowEditScientificDayModal(!showEditScientificDayModal)
    setSelectedScientificDay(ScientificDay)
    setSelectedModal(modalType.EditModal)
  }

  const toggleDeleteModal = (ScientificDay: ScientificDayInterface) => {
    setShowDeleteScientificDayModal(!showDeleteScientificDayModal)
    setSelectedScientificDay(ScientificDay)
    setSelectedModal(modalType.DeleteModal)
  }

  return (
    <div className='grid md:grid-cols-3 gap-2 mt-3'>
      {scientificDays.map((sDay: ScientificDayInterface, index: number) => {
        return <section className='bg-white rounded p-2 flex flex-col justify-between' key={index}>
          <ToggleImages sDay={sDay}/>
          <section>
            <div className='flex justify-between'>
              <b>{t("Titre")}: </b>
              <p>{sDay.theme}</p>
            </div>
            <div className='flex justify-between'>
              <b>{t("Societe")}: </b>
              <p>{sDay.RegFees}</p>
            </div>
            <div className='flex justify-between'>
              <b>{t("Date de fin")}: </b>
              <p>{formatDate(sDay.createdAt)}</p>
            </div>
          </section>
          <div className='flex justify-center'>
            <FaEdit className='text-second text-2xl' onClick={() => toggleEditModal(sDay)} />
            <MdRemoveCircleOutline className='text-red text-2xl' onClick={() => toggleDeleteModal(sDay)} />
          </div>
        </section>
      })}
    </div>
  )
}

export default DataScientificDay